export const apiKey = "https://azfreshdagitim-001-site2.ftempurl.com";